module.exports = __webpack_public_path__ + "static/media/POIncomingBIG.5481e6ac.svg";